import QRCode from 'react-qr-code';
import Env from '@/helpers/Env';

const isMobileBySize = () => {
  const width = window.innerWidth;
  const height = window.innerHeight;
  return (width <= 768 && height <= 1024);
}

export const DesktopWarning = () => {
  const { t } = useTranslation();
  const desktop = Env.desktop;
  const tablet = Env.tablet;
  const mobile = Env.mobile;

  const qrUrl = useMemo(() => {
    return "https://hawkstone.com/pages/hawkstone-beer-farmer-game"
    // return window.location.href;
  }, []);

  const showWarning = useMemo(() => {
    // console.log( "SHOW WARNING : ", Env.android_pixel, Env.instagram )
    // return true;
    if( desktop ){
      return true;
    }else{
      return !(( Env.android || Env.iphone ) && isMobileBySize())
    }
  }, []);

  return (
    <>
      {showWarning && (
        <div className="desktop-warning full pointer-events-auto z-[1000000] flex flex-col items-center justify-center bg-white">
          {/* <img
            src="assets/images/artboard-desktop.jpg"
            className="artboard"
          /> */}

          <img
            src="assets/images-next/desktop.webp"
            className="full object-cover"
          />

          <img
            src="assets/images-next/lockup.webp"
            className="absolute top-1/2 left-[11rem] h-[52rem] translate-y-[calc(-50%-9rem)]"
            alt={t('landing.heading')}
          />

          <img
            src="assets/images-next/hawkstone.webp"
            className="absolute bottom-[4rem] h-[5rem]"
            alt={t('landing.footer')}
          />

          <div className="text-stroke-white absolute top-[5rem] left-1/2 -translate-x-1/2">
            {t('desktop.heading')}
          </div>

          <div className="full flex flex-col items-end justify-center text-center">
            <div className="mr-[15%] flex flex-col items-center justify-center">
              <div className="typo-desktop">{t('desktop.scan.heading')}</div>

              <p className="font-gellix mt-3 mb-5 text-[3.4rem] leading-none font-medium whitespace-pre-line">
                {t('desktop.scan.desc')}
              </p>

              <div className="qrcode frame-beige px-3 py-5">
                <QRCode
                  bgColor="transparent"
                  fgColor="black"
                  size={512}
                  value={qrUrl}
                  className="qrcode relative h-[20rem] w-[20rem]"
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
